import { render } from "./FeriadoList.vue?vue&type=template&id=90eea0e8"
import script from "./FeriadoList.vue?vue&type=script&lang=js"
export * from "./FeriadoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__